<template>
    <ais-instant-search :search-client="searchClient" index-name="search" :routing="routing">
        <ais-configure :hits-per-page.camel="10" />

        <div class="container mb-12 md:my-24">
            <SearchBox />

            <div class="justify-between my-4 md:my-18 md:flex">
                <div class="flex-shrink-0 mb-2 md:mr-24 md:w-56 md:mb-0">
                    <SearchStats />
                    <SearchSuggestions class="hidden md:block" />
                </div>
                <div class="md:flex-grow">
                    <SearchQuery />
                    <SearchResults />
                </div>
            </div>
        </div>

        <div class="container mt-10 mb-14 md:-mt-6 md:mb-20">
            <SearchPagination />
        </div>
    </ais-instant-search>
</template>

<script>
import { ref } from '@vue/composition-api';
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import SearchBox from './SearchBox.vue';
import SearchStats from './SearchStats.vue';
import SearchResults from './SearchResults.vue';
import SearchQuery from './SearchQuery.vue';
import SearchPagination from './SearchPagination.vue';
import SearchSuggestions from './SearchSuggestions.vue';

const searchClient = algoliasearch(window.algoliaApplicationId, window.algoliaSearchApiKey);

export default {
    components: {
        SearchBox,
        SearchStats,
        SearchResults,
        SearchQuery,
        SearchPagination,
        SearchSuggestions
    },

    setup() {
        const routing = ref({
            router: historyRouter(),
            stateMapping: singleIndexMapping('search')
        });

        return {
            searchClient,
            routing
        };
    }
};
</script>
